import { createApp } from "vue"
import App from "./App.vue"
import rooter from "../src/router/index"
import install from "./install"
import { VueSvgIconPlugin } from "@yzfe/vue3-svgicon"
import "@yzfe/svgicon/lib/svgicon.css"
import "./registerServiceWorker"
import i18n from "./i18n"
import vuex from "./store";
import easySpinner from "vue-easy-spinner";
import Toaster from "@incuca/vue3-toaster";
import vClickOutside from "click-outside-vue3";

createApp(App)
    .use(i18n)
    .use(vuex)
    .use(VueSvgIconPlugin, { tagName: 'icon' })
    .use(install)
    .use(rooter)
    .use(Toaster)
    .use(easySpinner, {
     /*options*/
        prefix: "easy",
    })
    .use(vClickOutside)
    .mount('#app')
